import axios from '@/request/http'; // 导入http中创建的axios实例
import base from '@/request/api/base'// 导入接口域名列表
//调查问卷-培训班级相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/dcwj/planWjInfo/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/dcwj/planWjInfo/get/${params.id}`)
  },
  //保存修改
  save(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWjInfo/save`, params)
  },
  //保存修改
  update(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWjInfo/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/dcwj/planWjInfo/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWjInfo/batchDel`,params)
  },
  //批量删除
  getListByPwjId(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWjInfo/getListByPwjId/${params.pwjid}`)
  },


}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/dcwj/planWjInfo.js